<h3 class="mb-2">{{ 'powerBiUsage.title' | t }}</h3>
<span>
    {{ 'powerBiUsage.intro' | t }}
</span>
<span>
    <ul>
        <li>
            <a target="_blank" href="https://docs.microsoft.com/en-us/power-bi/fundamentals/">
                {{ 'powerBiUsage.linkGetStarted' | t }}
            </a>
        </li>
        <li>
            <a
                target="_blank"
                href="https://docs.microsoft.com/en-us/power-bi/fundamentals/desktop-what-is-desktop"
            >
                {{ 'powerBiUsage.linkDesktop' | t }}
            </a>
        </li>
        <li>
            <a target="_blank" href="https://docs.microsoft.com/en-us/power-bi/connect-data/">
                {{ 'powerBiUsage.linkConnectToData' | t }}
            </a>
            {{ 'powerBiUsage.webDataSourceNote' | t }}
        </li>
    </ul>
</span>

<h5>{{ 'powerBiUsage.registeringTitle' | t }}</h5>
<p>
    <span [innerHTML]="'powerBiUsage.registeringCreateApi' | t"></span>

    <span [innerHTML]="'powerBiUsage.registeringAddKey' | t"></span>

    <span [innerHTML]="'powerBiUsage.registeringKeyDetails' | t"></span>

    <span [innerHTML]="'powerBiUsage.registeringSave' | t"></span>

    <span class="centered">
        <img src="/static/images/manuals/api/api-creation.png" />
    </span>
</p>

<h5>{{ 'powerBiUsage.configuringTitle' | t }}</h5>
<p>
    <span [innerHTML]="'powerBiUsage.configuringExample' | t"></span>

    <span>
        {{ 'powerBiUsage.configuringGetData' | t }}
    </span>

    <span class="centered">
        <img src="/static/images/manuals/api/powerbi/powerbi-web-datasource.png" />
    </span>

    <span [innerHTML]="'powerBiUsage.configuringUrl' | t"></span>

    <span>
        {{ 'powerBiUsage.configuringCombine' | t }}
    </span>

    <span class="centered">
        <b>{{ apiUrl }}/riskdata/risk</b>
    </span>

    <span>
        {{ 'powerBiUsage.configuringAuthentication' | t }}
    </span>
    <span [innerHTML]="'powerBiUsage.configuringLevel' | t"></span>

    <span class="centered">
        <img src="/static/images/manuals/api/powerbi/powerbi-web-config.png" />
    </span>

    <span>
        {{ 'powerBiUsage.configuringConnect' | t }}
    </span>
</p>

<h5>{{ 'powerBiUsage.transformingTitle' | t }}</h5>
<p>
    <span>
        {{ 'powerBiUsage.transformingIntro' | t }}
    </span>

    <span>
        {{ 'powerBiUsage.transformingUndo' | t }}
    </span>

    <span>
        {{ 'powerBiUsage.transformingIntoTable' | t }}
    </span>

    <span>
        {{ 'powerBiUsage.transformingTranspose' | t }}
    </span>

    <span class="centered">
        <img src="/static/images/manuals/api/powerbi/powerbi-source-transformation.png" />
    </span>

    <span>
        {{ 'powerBiUsage.transformingSourceQuery' | t }}
    </span>

    <span class="centered">
        <img src="/static/images/manuals/api/powerbi/powerbi-source-query-config.png" />
    </span>

    <span>
        {{ 'powerBiUsage.transformingReference' | t }}
    </span>

    <span>
        {{ 'powerBiUsage.transformingEnableLoad' | t }}
    </span>

    <span>
        {{ 'powerBiUsage.transformingRemoveColumns' | t }}
    </span>

    <span>
        {{ 'powerBiUsage.transformingExpandRows' | t }}
    </span>

    <span class="centered">
        <img src="/static/images/manuals/api/powerbi/powerbi-table-extract.png" />
    </span>

    <span>
        {{ 'powerBiUsage.transformingExpandColumns' | t }}
    </span>

    <span>
        <b>{{ 'powerBiUsage.transformingRedoWarning' | t }}</b>
    </span>

    <span class="centered">
        <img src="/static/images/manuals/api/powerbi/powerbi-column-extract.png" />
    </span>

    <span>
        {{ 'powerBiUsage.transformingCloseAndApply' | t }}
    </span>
</p>

<h5>{{ 'powerBiUsage.finalStepsTitle' | t }}</h5>
<p>
    <strong>{{ 'powerBiUsage.sharingTitle' | t }}</strong>
    <span [innerHTML]="'powerBiUsage.sharingText' | t"></span>

    <strong>{{ 'powerBiUsage.renamingTitle' | t }}</strong>
    <span [innerHTML]="'powerBiUsage.renamingText' | t"></span>

    <strong>{{ 'powerBiUsage.relationshipsTitle' | t }}</strong>
    <span [innerHTML]="'powerBiUsage.relationshipsText' | t"></span>
</p>
